@if (useStandard) {
  <crm-standard-single-select
    [descriptorApiUrl]="descriptorUrl"
    [selectedValue]="costCenterId !== undefined ? null : selectedCostCenter"
    [selectedKey]="costCenterId"
    (selectedValueChange)="onSelected($event)"
    [labelInput]="labelInput"
    labelInputText="Центр затрат"
    [class]="class"
    [styleClass]="styleClass"
    [showClear]="showClear"
    [disabled]="disabled"
    [isError]="isError"
    [appendTo]="appendTo"></crm-standard-single-select>
} @else {
  <crm-single-select
    [options]="costCenters"
    [selectedItem]="selectedCostCenter"
    (selectedItemChange)="onSelected($event)"
    [label]="labelInput ? 'Центр затрат' : ''"
    [showClear]="showClear"
    [styleClass]="styleClass"
    [class]="class"
    [appendTo]="appendTo"
    [disabled]="disabled"
    [isError]="isError"
    [loading]="loading || selectionLoading"></crm-single-select>
}
